import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Produto } from 'src/app/models/produto';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { ProdutoService } from 'src/app/services/produto.service';

@Component({
  selector: 'app-layout-modal',
  templateUrl: './layout-modal.component.html',
  styleUrls: ['./layout-modal.component.scss']
})
export class LayoutModalComponent implements OnInit {
  tensoesMo = [{ id: 1, nome: '220' }];
  tensoesBi = [{ id: 1, nome: '220' }, { id: 2, nome: '380' }];
  tensoesTri = [{ id: 1, nome: '220' }, { id: 2, nome: '380' }, { id: 3, nome: '+380' }];
  fases = [
    { id: 0, nome: 'Monofásico' },
    // { id: 1, nome: 'Bifásico' },
    { id: 2, nome: 'Trifásico' }
  ];
  faseSelecionada: any;
  tensaoSelecionada: any;
  painelSelecionado: any;
  paineis: Produto[] = [];

  erroFaseSelecionada = false;
  erroTensaoSelecionada = false;
  multiFornecedores = false;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(public dialogRef: MatDialogRef<LayoutModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private produtoService: ProdutoService,
    private carregandoService: CarregandoService, private premissasService: PremissasService, private notificacaoService: NotificacaoService) {
    this.faseSelecionada = data.fase;
    this.tensaoSelecionada = data.tensao;
    this.painelSelecionado = data.painel;
  }

  ngOnInit() {
    this.buscarMultiFornecedores();
    this.buscarMostrarBifasico();
    this.buscarPaineis();
  }

  selecionarTensao() {
    this.erroTensaoSelecionada = false;
  }
  selecionarFase() {
    this.tensaoSelecionada = undefined;
  }

  buscarPaineis() {
    this.carregandoService.mostra('buscaPaineis');

    this.produtoService.buscarPaineis().subscribe(
      (pa) => {
        this.paineis = pa;
        this.carregandoService.esconde('buscaPaineis');
      },
      (erro) => {
        this.carregandoService.esconde('buscaPaineis');
      }
    );
  }

  ok(layoutForm) {

    if (layoutForm.valid) {

      this.carregandoService.mostra('buscaPaineis');

      this.produtoService.consultarPorId(this.painelSelecionado, this.multiFornecedores).subscribe(
        (pa: Produto) => {
          let retorno = {
            tensaoSelecionada: this.tensaoSelecionada,
            faseSelecionada: this.faseSelecionada,
            painelSelecionado: pa
          };

          this.dialogRef.close(retorno);
          this.carregandoService.esconde('buscaPaineis');
        },
        (erro) => {
          this.carregandoService.esconde('buscaPaineis');
        }
      );



      // this.contaEnergia.outrasCobrancas = Number(this.contaEnergia.outrasCobrancas.toString().replace(',','.'));
      // this.contaEnergia.idCupom = this.idCupom;
      // this.dialogRef.close(this.contaEnergia);
    }

    if (this.tensaoSelecionada === undefined || this.tensaoSelecionada === null) {
      this.erroTensaoSelecionada = true;
    }
    // if(this.contaEnergia.classe === undefined || this.contaEnergia.classe === null){
    //   this.erroClasseSelecionada = true;
    // }
    // else {
    //   this.notificacaoService.erro('Preencha todos os campos obrigatórios.');
    // }
  }

  voltar() {
    this.dialogRef.close();
  }

  validar() {
    return this.tensaoSelecionada !== undefined && this.tensaoSelecionada !== null && this.painelSelecionado !== undefined && this.painelSelecionado !== null && this.faseSelecionada !== undefined && this.faseSelecionada !== null;
    //return this.tensao !== undefined && this.tensao !== null && this.fase !== undefined && this.fase !== null;
  }

  buscarMostrarBifasico() {
    this.carregandoService.mostra('buscarMostrarBifasico');
    this.premissasService.consultarMostrarBifasico().subscribe(f => {
      if (f.valor) {
        this.fases[0].nome = 'Monofásico/Bifásico';
        this.fases = [...this.fases];
      }
      this.carregandoService.esconde('buscarMostrarBifasico');
    }, (erro) => {
      this.carregandoService.esconde('buscarMostrarBifasico');
      this.notificacaoService.erro(erro);
    });
  }

  buscarMultiFornecedores() {
    this.carregandoService.mostra('buscarMultiFornecedores');
    this.premissasService.consultarMultiFornecedores().subscribe(f => {
      this.multiFornecedores = f.valor;
      this.carregandoService.esconde('buscarMultiFornecedores');
    }, (erro) => {
      this.carregandoService.esconde('buscarMultiFornecedores');
      this.notificacaoService.erro(erro);
    });
  }

}
